import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AppDownloadConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getAppStoreUrl(): string {
		return this.config.get((x) => x.common.appDownload?.endpoints?.appStoreUrl, "");
	}

	getAndroidAppUrl(): string {
		return this.config.get((x) => x.common.appDownload?.endpoints?.androidAppUrl, "");
	}
}
